import { Link } from "react-router-dom";
import { usePackages } from "../hooks/usePackages.js";
import { useAdmins } from "../hooks/useAdmins.js";
import { useAudit } from "../hooks/useAudit.js";
import { formatRelative } from "../lib/format.js";

export function DashboardPage() {
  const pkgs = usePackages();
  const admins = useAdmins();
  const audit = useAudit({});

  const totalPkgs = pkgs.data?.length ?? 0;
  const livePkgs = pkgs.data?.filter((p) => p.yanked === 0).length ?? 0;
  const activeAdmins = admins.data?.filter((a) => a.disabled === 0).length ?? 0;
  const totalDownloads =
    pkgs.data?.reduce((sum, p) => sum + p.download_count, 0) ?? 0;
  const recent = audit.data?.slice(0, 10) ?? [];

  return (
    <div>
      <h1 className="page-title">Dashboard</h1>
      <p className="page-sub">mhwork-hub 运营概览</p>

      {/* 统计卡 */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: 14,
          marginTop: 20,
        }}
      >
        <StatCard
          label="包总数"
          value={totalPkgs}
          sub={`${livePkgs} 上架中`}
          color="var(--primary)"
          icon="◫"
        />
        <StatCard
          label="管理员"
          value={activeAdmins}
          sub={`${admins.data?.length ?? 0} 全部账号`}
          color="#10b981"
          icon="◉"
        />
        <StatCard
          label="累计下载"
          value={totalDownloads}
          sub="所有版本合计"
          color="#f59e0b"
          icon="⇣"
        />
        <StatCard
          label="近期活动"
          value={recent.length}
          sub="最近审计事件"
          color="#8b5cf6"
          icon="≡"
        />
      </div>

      {/* 最近活动 */}
      <div style={{ marginTop: 28 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
          <h2 style={{ fontSize: 16, margin: 0, fontWeight: 600 }}>最近活动</h2>
          <Link to="/audit" style={{ fontSize: 12 }}>
            查看全部 →
          </Link>
        </div>
        <div className="card">
          {audit.isLoading ? (
            <div className="empty">加载中…</div>
          ) : recent.length === 0 ? (
            <div className="empty">暂无审计记录</div>
          ) : (
            recent.map((e, i) => (
              <div
                key={e.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "12px 16px",
                  borderBottom:
                    i < recent.length - 1 ? "1px solid var(--border-soft)" : 0,
                  fontSize: 13,
                }}
              >
                <ActionDot action={e.action} />
                <span className="pill pill-neutral">{e.action}</span>
                <code style={{ fontSize: 12, color: "var(--text)" }}>{e.target}</code>
                <span
                  style={{
                    marginLeft: "auto",
                    fontSize: 11,
                    color: "var(--text-muted)",
                  }}
                >
                  {formatRelative(e.ts)}
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

function StatCard({
  label,
  value,
  sub,
  color,
  icon,
}: {
  label: string;
  value: number;
  sub?: string;
  color: string;
  icon: string;
}) {
  return (
    <div className="card" style={{ padding: 18 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            background: color,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 18,
            fontWeight: 600,
            boxShadow: `0 2px 8px ${color}40`,
          }}
        >
          {icon}
        </div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontSize: 11,
              color: "var(--text-muted)",
              textTransform: "uppercase",
              letterSpacing: "0.04em",
            }}
          >
            {label}
          </div>
        </div>
      </div>
      <div style={{ fontSize: 28, fontWeight: 600, marginTop: 10, letterSpacing: "-0.02em" }}>
        {value.toLocaleString()}
      </div>
      {sub && (
        <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}>
          {sub}
        </div>
      )}
    </div>
  );
}

function ActionDot({ action }: { action: string }) {
  const color =
    action.includes("yank") || action.includes("disable") || action.includes("delete")
      ? "var(--danger)"
      : action.includes("publish") || action.includes("create")
        ? "var(--success)"
        : "var(--info)";
  return (
    <span
      style={{
        width: 6,
        height: 6,
        borderRadius: "50%",
        background: color,
        flexShrink: 0,
      }}
    />
  );
}
